require('./blocks/textpage.less');
require('./blocks/form/form.less');
require('./blocks/textblock.less');
require('./blocks/vacancy/vacancy.less');
require('./blocks/vacancy/vacancy.js');
require('./blocks/textblock.js');



// WEBPACK FOOTER //
// ./vacancy.js